export type USStateCode = keyof typeof USCodeToState;
export type USStateName = (typeof USCodeToState)[USStateCode];

export const USCodeToState = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

export const USStateToCode: Record<USStateName, USStateCode> = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District of Columbia': 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

export const USCodeToGeoCenter: Record<
  USStateCode,
  { lat: number; lng: number }
> = {
  AL: { lat: 32.8417, lng: -86.6333 },
  AK: { lat: 64.7319, lng: -152.47 },
  AZ: { lat: 34.3083, lng: -111.7933 },
  AR: { lat: 34.8167, lng: -92.3 },
  CA: { lat: 36.965, lng: -120.0817 },
  CO: { lat: 38.9983, lng: -105.6417 },
  CT: { lat: 41.595, lng: -72.7067 },
  DE: { lat: 38.98, lng: -75.5117 },
  FL: { lat: 28.1333, lng: -81.635 },
  GA: { lat: 32.7133, lng: -83.495 },
  HI: { lat: 20.9517, lng: -157.2767 },
  ID: { lat: 44.2567, lng: -114.9567 },
  IL: { lat: 40.0133, lng: -89.3067 },
  IN: { lat: 39.895, lng: -86.2667 },
  IA: { lat: 41.9617, lng: -93.385 },
  KS: { lat: 38.4983, lng: -98.6983 },
  KY: { lat: 37.3583, lng: -85.5067 },
  LA: { lat: 30.9683, lng: -92.5367 },
  ME: { lat: 45.2533, lng: -69.2333 },
  MD: { lat: 39.4417, lng: -77.3733 },
  MA: { lat: 42.34, lng: -72.0317 },
  MI: { lat: 45.0617, lng: -84.9383 },
  MN: { lat: 46.025, lng: -95.3267 },
  MS: { lat: 32.815, lng: -89.7167 },
  MO: { lat: 38.495, lng: -92.63 },
  MT: { lat: 47.0317, lng: -109.6383 },
  NE: { lat: 41.525, lng: -99.8617 },
  NV: { lat: 39.505, lng: -116.9317 },
  NH: { lat: 43.6417, lng: -71.5717 },
  NJ: { lat: 40.07, lng: -74.5583 },
  NM: { lat: 34.5017, lng: -106.1117 },
  NY: { lat: 42.965, lng: -76.0167 },
  NC: { lat: 35.6033, lng: -79.455 },
  ND: { lat: 47.4133, lng: -100.5683 },
  OH: { lat: 40.3617, lng: -82.7417 },
  OK: { lat: 35.5367, lng: -97.66 },
  OR: { lat: 43.8683, lng: -120.9783 },
  PA: { lat: 40.8967, lng: -77.7467 },
  RI: { lat: 41.6722, lng: -71.5767 },
  SC: { lat: 33.83, lng: -80.8733 },
  SD: { lat: 44.4017, lng: -100.4783 },
  TN: { lat: 35.795, lng: -86.6217 },
  TX: { lat: 31.2433, lng: -99.4583 },
  UT: { lat: 39.3867, lng: -111.685 },
  VT: { lat: 43.9267, lng: -72.6717 },
  VA: { lat: 37.4883, lng: -78.5633 },
  WA: { lat: 47.3333, lng: -120.2683 },
  DC: { lat: 39.1667, lng: -77.85 },
  WV: { lat: 38.5983, lng: -80.7033 },
  WI: { lat: 44.4333, lng: -89.7633 },
  WY: { lat: 42.9717, lng: -107.6717 },
};

export const isStateCode = (code: string): code is USStateCode =>
  !!USCodeToState[code as USStateCode];

export const isStateName = (name: string): name is USStateName =>
  !!USStateToCode[name as USStateName];
